@if (sectionLabel) {
  <div class="material-section-header">
    <div class="material-section-label">{{ sectionLabel }}</div>
    <div class="material-section-divider"></div>
  </div>
}
<div class="material-section-body" [class.top-space]="hasTopSpace">
  <ng-content></ng-content>
</div>
